import { createDecorator } from 'vue-class-component';
import { mapState, mapGetters, mapActions } from 'vuex';
export const state = createBindingHelper('computed', mapState);
export const getter = createBindingHelper('computed', mapGetters);
export const action = createBindingHelper('methods', mapActions);

function createBindingHelper(bindTo, mapFn) {
   return function makeDecorator(map) {
      return createDecorator(function _decorator(options, key) {
         map = map || key;
         options[bindTo] = options[bindTo] || {};
         options[bindTo][key] = mapFn({ [key]: map })[key];
      });
   };
}
